import React, { useContext } from 'react';
import * as R from 'ramda';
import { func } from 'prop-types';

// Components
import { Box } from '@mui/material';
import Buttons from '../../components/Buttons';
import ProductCheckboxList from '../../components/ProductCheckboxList.connector';
import SummaryDrawer from '../../components/SummaryDrawer';

// Context
import { SequencingWizardContext } from '../../SequencingWizardContext';

const SequenceStep2 = ({ next, prev }) => {
  const {
    data: { inventoryOwners = [], products = [] },
    setData,
  } = useContext(SequencingWizardContext);

  const continueDisabled = R.isEmpty(products);
  const handleChange = R.o(setData, R.assoc('products'));

  return (
    <>
      <Box
        sx={{
          display: 'flex',
          flexDirection: 'column',
          // height of other components is 203px
          // prevents progress bar from looking off
          height: 'calc(100% - 203px)',
          // Prevents bottom selection from clipping on Y overflow
          marginBottom: 46,
          overflowY: 'auto',
        }}
      >
        <Box flexGrow={1}>
          <ProductCheckboxList
            inventoryOwners={inventoryOwners}
            onChange={handleChange}
            title="Select one or more products"
          />
        </Box>
        <SummaryDrawer inventoryOwnerSubtitle="Selected Inventory Owner" />
      </Box>
      <Buttons
        disabled={continueDisabled}
        handleLeftButtonClick={prev}
        handleRightButtonClick={next}
        leftLabel="Back"
        rightLabel="Continue"
      />
    </>
  );
};

SequenceStep2.propTypes = {
  next: func.isRequired,
  prev: func.isRequired,
};

export default SequenceStep2;
